import styles from './StarsCrm.scss';

export const zoneStyles = {
  SWREWARDSOPTIN: styles.rewardsOptin,
  SWREWARDSINFO: styles.rewardsInfo,
  WSLTARGETED: styles.targetedNews,
  MODALZONE: styles.modalZone,
  FLOATINGOFFER: styles.floatingOffer
};
